import { render } from "./GameComponent.vue?vue&type=template&id=bd3a19ee&ts=true"
import script from "./GameComponent.vue?vue&type=script&lang=ts"
export * from "./GameComponent.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__